import React from 'react';
import './DateInput.scss';
import InputError from "../InputError";

export default function DateInput({ label, placeholder, required, onChange, disabled, value, error, description, ...rest }) {
    return (
        <div className={"date-input" + (required ? ' required ' : '')}>
            {label && <label>{label}</label>}
            <input
                {...rest}
                type="date"
                placeholder={placeholder}
                onChange={onChange}
                disabled={disabled}
                value={value}
                className={`form-control ${error ? 'is-invalid' : ''}`}
            />
            {description ? <p className="description">{description}</p> : null}
            {error ? <InputError error={error}/> : null}
        </div>
    );
}